import apiClient from "./apiClient";

const multipart = { headers: { "Content-Type": "multipart/form-data" } };

export const calculations = (mw, std_fp) =>
    apiClient.get(`/calculations/${mw}/${std_fp}`);

export const fpCalculations = (mw) =>
    apiClient.get(`/fp-calculations/${mw}`);

export const loadExcelSTDMonthly = (formData) =>
    apiClient.post("/load-excel-std-monthly", formData, multipart);

export const loadExcelSTDWeekly = (formData) =>
    apiClient.post("/load-excel-std-weekly", formData, multipart);

export const loadExcelFP = (formData) =>
    apiClient.post("/load-excel-fp", formData, multipart);

export const results = (id) => apiClient.get(`/results/${id}`);

export const fpResults = (id) => apiClient.get(`/fp-results/${id}`);